export function toggleHideById(id) {
  document.getElementById(id).classList.toggle('hide');

}

export function emailVAlidation(control){
  const email = control.value;
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/;

    
    if(email == null){
      return {'required':true}
    }else{
      if (pattern.test(email)) {
        return null; // Valid email
      }
       else {
        return { 'invalidEmail': true }; // Invalid email
      }
    } 
}

export function nameValidation(control){
  const name = control.value;
  const pattern = /^(?! )(?!\s)[a-zA-Z][a-zA-Z0-9\s!@#$%^&*()-_+=<>?/{}|]*(?: [a-zA-Z][a-zA-Z0-9\s!@#$%^&*()-_+=<>?/{}|]+)*(?<!\s)$/;


  if (name == null || name.trim() === '') {
    return { 'required': true };
  } else if (name.startsWith(' ') || name.endsWith(' ')) {
    return { 'spaceIssue': true };
  } else {
    if (pattern.test(name)) {
      return null;
    } else {
      return { 'invalidName': true };
    }
  }
}

export function validateKeyPress(event): void {
  const pattern = /^[a-zA-Z0-9\s!@#$%^&*()-_+=<>?/{}|]*$/;
  if (!pattern.test(event.key)) {
    event.preventDefault();
  }
}

export function getLevel(roleId){
  if (roleId >= 1 && roleId <= 9) {
    return "Super Level"
  } else if (roleId >= 10 && roleId <= 99) {
    return "Account Level"
  } else if (roleId >= 100 && roleId <= 999) {
    return "Corporate Level"
  } else if (roleId >= 1000 && roleId <= 9999) {
    return "Level I"
  } else if (roleId >= 10000 && roleId <= 99999) {
    return "Level II"
  }else{
    return ""
  }
}

export function passwordValidation(event){
  const password = event.value;
  if(password == null || password.trim() === '') {
    return { 'required': true };
  }
  const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;

  if (!passwordPattern.test(password)) {
    return { weakPassword: true };
  }
}
